module.exports = __webpack_public_path__ + "img/cn_pocket-21.31eb28a.jpg";